<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->
<p-sidebar
  *ngIf="subjectId && subjectType"
  [(visible)]="isVisible"
  [showCloseIcon]="false"
  position="right"
  [baseZIndex]="1012"
  (onHide)="onHide()"
  [styleClass]="'activities-sidebar-static ' + classes"
  [modal]="overlay"
>
  <app-side-button [icon]="'far fa-times'" [customClasses]="'btn-close'" (click)="closeSidebar()"></app-side-button>

  <p-tabView class="activities-sidebar-tabs h-100 d-flex flex-column" [activeIndex]="tabsIndex">
    <div class="new-header">
      <div (click)="openTab(0)" class="btn-tab" [ngClass]="{ selected: tabsIndex === 0 }">
        {{ 'ACTIVITIES_SIDEBAR.ACTIONS' | translate }}
      </div>
      <div (click)="openTab(1)" class="btn-tab" [ngClass]="{ selected: tabsIndex === 1 }">
        {{ 'ACTIVITIES_SIDEBAR.ACTIVITY' | translate }}
      </div>
    </div>
    <p-tabPanel *ngIf="tabsIndex===0">
      <app-comments
        class="app-comments"
        [subjectId]="subjectId"
        [subjectType]="subjectType"
        *ngIf="subjectId && subjectType"
      ></app-comments>
    </p-tabPanel>
    <p-tabPanel *ngIf="tabsIndex===1" [cache]="true" class="activities-tab">
      <ng-template pTemplate="content">
          <p-dataView
            [value]="activityResponse.data"
            [paginator]="true"
            [rows]="activityResponse.meta?.per_page"
            [totalRecords]="activityResponse.meta?.total"
            [lazy]="true"
            (onLazyLoad)="paginate($event)"
            [loading]="loading"
            [alwaysShowPaginator]="false"
          >
            <ng-template pTemplate="list" let-activities>
              <div *ngFor="let activity of activities" class="activity-item">
                <div *ngIf="activity && activity.isModelActivity()">
                  <div *ngFor="let propertyKey of activity.getKeys()">
                    <strong>Key:</strong> {{ propertyKey }} <br />
                    {{ activity.getOldValue(propertyKey) || 'EMPTY' }}
                    /
                    {{ activity.getNewValue(propertyKey) || 'EMPTY' }}
                    <pre
                      diff
                      [left]="toString(activity.getOldValue(propertyKey) || 'EMPTY')"
                      [right]="toString(activity.getNewValue(propertyKey) || 'EMPTY')"
                    ></pre>
                  </div>
                </div>

                <div *ngIf="!activity.isModelActivity()">
                  <div class="word-break">{{ stringify(activity.properties) }}</div>
                </div>

                <i class="fal fa-arrow-right"></i>
                {{ activity.description }} &#64;
                {{ activity.created_at.getDateTime() }} /
                {{ activity?.causer?.first_name }} {{ activity?.causer?.last_name }}
              </div>
            </ng-template>
          </p-dataView>
      </ng-template>
    </p-tabPanel>
  </p-tabView>
</p-sidebar>
